import { useTranslation } from 'react-i18next';
import { Details } from '@digdir/designsystemet-react';
import classes from '../CustomSurveyTemplateTrendsPage.module.css';

type ResultsGuideProps = {
  /** Utvikling over tid forklarer endringen og streken, én undersøkelse forklarer svarene hver for seg */
  view: 'trends' | 'survey';
};

/** Kort forklaring av tallene, så de er lette å forstå uten forkunnskaper */
export const ResultsGuide = ({ view }: ResultsGuideProps) => {
  const { t } = useTranslation();
  const items =
    view === 'trends'
      ? ['average', 'median', 'change', 'marker', 'nps', 'privacy']
      : ['average', 'median', 'nps', 'individual', 'privacy'];

  return (
    <Details className={classes.guide}>
      <Details.Summary>{t('customSurveys.templateTrends.guide.title')}</Details.Summary>
      <Details.Content>
        <ul className={classes.guideList}>
          {items.map((item) => (
            <li key={item}>{t(`customSurveys.templateTrends.guide.${item}`)}</li>
          ))}
        </ul>
      </Details.Content>
    </Details>
  );
};
